import _axios from 'axios';

class Axios {
    /**
     * Собираем нужные пармерты
     * @param method
     * @param url
     * @param params
     * @param errors
     * @param clearErrors
     */
    parseData({ method, url, params, errors, resetErrors = true, resetForm = false }) {
        this.method = method ? method.toUpperCase().trim() : undefined;
        this.url = url;
        this.params = params;
        this.errors = errors;
        this.resetErrors = resetErrors;
        this.resetForm = resetForm;
    }

    /**
     * constructor
     * @param Vue
     * @param options
     * @param data
     * @returns {void | Promise}
     */
    constructor(Vue, options, data) {
        this.vue = Vue;
        this.options = options;
        this.data = data;
        this.lodash = Vue.prototype._;
        if (!data) {
            return this.notifyException('Object axios data not fount.');
        }
        this.parseData(data);
        if (!this.method || ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].indexOf(this.method.toUpperCase().trim()) === -1) {
            return this.notifyException('Unknown method.');
        }
        if (!this.url) {
            return this.notifyException('Invalid url.');
        }
        return this.event();
    }

    /**
     * Событие
     */
    event() {
        let obj = {
            method: this.method,
            url: this.url
        };
        if (this.method === 'GET') {
            obj.params = this.params;
        } else {
            obj.data = this.params;
        }
        _axios(obj).then(
            (response) => {
                if (this.data.success) {
                    this.clearErrors();
                    if (this.resetForm && this.method === 'POST') {
                        this.recursiveClearParams(this.params);
                    }
                    return this.data.success(response.data);
                }
            },
            (error) => {
                return this.errorHandler(error);
            }
        );
    }

    /**
     *
     * @param params
     * @returns {*}
     */
    recursiveClearParams = (params) => {
        this.lodash.forEach(params, (v, k) => {
            if (typeof v === 'object' || Array.isArray(v)) {
                this.recursiveClearParams(params[k]);
            } else {
                switch (typeof params[k]) {
                    case 'string':
                        params[k] = '';
                        break;
                    case 'number':
                        params[k] = 0;
                        break;
                    default:
                        params[k] = undefined;
                }
            }
        });
    };

    /**
     * Очистка ошибок валидации.
     * @returns {*}
     */
    clearErrors() {
        if (!this.errors || !this.resetErrors) return;
        return this.lodash.forEach(this.errors, (v, k) => {
            this.errors[k] = '';
        });
    }

    /**
     * Обработка статусов и ошибок
     * @param error
     * @returns {void|*}
     */
    errorHandler(error) {
        let resp = error.response;
        if (resp) {
            switch (resp.status) {
                case 401:
                    return this.notify('Error Status Code 401', 'Unauthorized');
                case 403:
                    return this.notify('Error Status Code 403', 'Access Denied');
                case 422:
                    this.clearErrors();
                    if (this.data.catch) {
                        this.data.catch(resp);
                    }
                    if (this.errors) {
                        return this.lodash.forEach(resp.data.errors, (value, key) => {
                            this.errors[key] = this.errors[key] || this.errors[key] === '' ? value[0] : '';
                        });
                    }
                    return;
            }
        }
        let message = resp && resp.data.error && resp.data.error !== '' ? resp.data.error : 'The server returned an error';
        // this.notify('Server Error!', message);
        if (this.data.catch) {
            return this.data.catch(error);
        }
    }

    /**
     * Axios Exception
     * @param message
     */
    notifyException(message) {
        this.notify('Axios Exception!', message);
    }

    /**
     * Axios Notify
     * @param title
     * @param text
     * @param color
     */
    notify(title, text, color = 'danger') {
        this.vue.prototype.$vs.notify({
            title: title,
            text: text,
            color: color
        });
    }
}

export default {
    install(Vue, options) {
        Vue.prototype.$axios = (data) => {
            return new Axios(Vue, options, data);
        };
    }
};
